import type { TReaderDocument } from '@app-evolution-cms/email-builder';

import { EMAIL_COLOR } from './colors';
import { FONT_FAMILY_ITEM } from './font-family';

export type InsertableBlockType =
  | 'header'
  | 'text'
  | 'button'
  | 'image'
  | 'avatar'
  | 'divider'
  | 'space'
  | 'html'
  | 'column'
  | 'container'
  | 'block';

export const NEW_BLOCKS = {
  header: {
    type: 'Heading',
    data: {
      props: { text: 'Encabezado', level: 'h1' },
      style: {
        color: EMAIL_COLOR.accent,
        fontFamily: FONT_FAMILY_ITEM.modernSans,
        fontWeight: 'bold',
        textAlign: 'left',
        padding: { top: 16, bottom: 16, left: 16, right: 16 },
      },
    },
  },
  text: {
    type: 'Text',
    data: {
      props: {
        markdown: true,
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
      },
      style: {
        color: EMAIL_COLOR.primary,
        fontSize: 16,
        fontFamily: FONT_FAMILY_ITEM.modernSans,
        fontWeight: 'normal',
        textAlign: 'left',
        padding: { top: 16, bottom: 16, left: 16, right: 16 },
      },
    },
  },
  button: {
    type: 'Button',
    data: {
      props: {
        buttonBackgroundColor: EMAIL_COLOR.accent,
        buttonStyle: 'pill',
        buttonTextColor: EMAIL_COLOR.primaryInverted,
        fullWidth: true,
        size: 'medium',
        text: 'Botón',
        url: 'https://gbm.com/',
      },
      style: {
        fontSize: 16,
        fontWeight: 'bold',
        textAlign: 'center',
        padding: { top: 16, bottom: 16, left: 16, right: 16 },
      },
    },
  },
  image: {
    type: 'Image',
    data: {
      props: {
        url: 'https://cdn.stg-gbm.com/cms/image/visual-sc.gif',
        alt: 'Lorem ipsum',
        linkHref: 'https://gbm.com/',
        contentAlignment: 'middle',
      },
      style: {
        textAlign: 'left',
        padding: { top: 16, bottom: 16, left: 16, right: 16 },
      },
    },
  },
  avatar: {
    type: 'Avatar',
    data: {
      props: {
        size: 64,
        shape: 'circle',
        imageUrl: 'https://ui-avatars.com/api/?size=64',
        alt: 'Lorem ipsum',
      },
      style: {
        textAlign: 'left',
        padding: { top: 16, bottom: 16, left: 16, right: 16 },
      },
    },
  },
  divider: {
    type: 'Divider',
    data: {
      props: {
        lineColor: EMAIL_COLOR.secondary,
        lineHeight: 1,
      },
      style: {
        padding: { top: 16, bottom: 16, left: 0, right: 0 },
      },
    },
  },
  space: {
    type: 'Spacer',
    data: {
      props: {
        height: 32,
      },
    },
  },
  html: {
    type: 'Html',
    data: {
      props: {
        contents: '<strong>Lorem ipsum</strong>',
      },
      style: {
        color: EMAIL_COLOR.primary,
        fontFamily: FONT_FAMILY_ITEM.modernSans,
        fontSize: 16,
        textAlign: 'left',
        padding: { top: 16, bottom: 16, left: 16, right: 16 },
      },
    },
  },
  column: {
    type: 'ColumnsContainer',
    data: {
      props: {
        columnsCount: 2,
        columnsGap: 16,
        contentAlignment: 'middle',
        columns: [{ childrenIds: [] }, { childrenIds: [] }, { childrenIds: [] }],
      },
      style: {
        padding: { top: 16, bottom: 16, left: 16, right: 16 },
      },
    },
  },
  container: {
    type: 'Container',
    data: {
      props: {
        childrenIds: [],
      },
      style: {
        borderRadius: 0,
        padding: { top: 16, bottom: 16, left: 16, right: 16 },
      },
    },
  },
  block: {
    type: 'Container',
    data: {
      props: { childrenIds: [] },
      style: {
        borderRadius: 0,
        padding: { top: 16, bottom: 16, left: 16, right: 16 },
      },
    },
  },
} satisfies Record<InsertableBlockType, TReaderDocument[string]>;
